import { LandingNav, LandingFooter } from "@/components/landing/NavFooter";
import { Hero } from "@/components/landing/Hero";
import { Problem } from "@/components/landing/Problem";
import { HowItWorks, Benefits } from "@/components/landing/Steps";
import { Pricing, Faq } from "@/components/landing/PricingFaq";

export default function Home() {
  return (
    <div className="grain min-h-screen bg-slate-50" data-testid="home-page">
      <div className="relative z-10">
        <LandingNav />
        <main>
          <Hero />
          <Problem />
          <HowItWorks />
          <Benefits />
          <Pricing />
          <Faq />
        </main>
        <LandingFooter />
      </div>
    </div>
  );
}
